import React from 'react';
import { useLocation } from 'react-router-dom';
import OneRealLogo from '../../assets/img/auth/auth-one-real-logo.png';
import RealBrandLogo from '../../assets/img/real-brand-logo.svg';
import { AnalyticsEventEnum } from '../../types';
import { cn } from '../../utils/classUtils';
import AnalyticsEventOnLoad from '../Analytics/AnalyticsEventOnLoad';
import AuthPageRightSection from './AuthPageRightSection';

interface AuthPageLayoutProps {
  children: React.ReactNode;
  eventName?: AnalyticsEventEnum;
  containerClassName?: string;
  rightSection?: React.ReactNode;
  isAgentContext?: boolean;
  showRightSection?: boolean;
}

const AuthPageLayout: React.FC<AuthPageLayoutProps> = ({
  children,
  eventName,
  containerClassName,
  rightSection,
  isAgentContext,
  showRightSection = true,
}) => {
  const location = useLocation();
  const showOnboardingLogin =
    isAgentContext ?? location.pathname === '/agent-login';
  const isGenericLogin = location.pathname === '/login';

  return (
    <div
      className={cn(
        'grid grid-cols-1 h-screen',
        showRightSection && 'lg:grid-cols-2',
      )}
    >
      <div
        className={cn(
          'lg:col-span-1 lg:place-content-start lg:bg-none bg-no-repeat bg-contain lg:bg-white bg-primary-navy lg:h-screen py-4',
          showOnboardingLogin || isGenericLogin
            ? 'bg-none place-content-start'
            : 'bg-[url(/src/assets/img/auth/auth-mobile-bg.png)] place-content-center',
        )}
      >
        {(showOnboardingLogin || isGenericLogin) && (
          <div
            className={cn(
              showOnboardingLogin || isGenericLogin
                ? 'lg:hidden flex justify-center items-start pt-2 pb-32'
                : 'pt-0 pb-0',
            )}
          >
            <img
              src={RealBrandLogo}
              alt='real-brand-logo'
              width={90}
              height={50}
            />
          </div>
        )}
        <div className='lg:h-full auth-custom-scroll'>
          {!showOnboardingLogin && !isGenericLogin && (
            <div
              className={cn(
                'hidden',
                !showRightSection
                  ? 'lg:flex justify-center pt-14 pb-10'
                  : 'lg:block px-16 pt-16 pb-6',
              )}
            >
              <img
                src={OneRealLogo}
                alt='placeholder'
                width={170}
                height={50}
              />
            </div>
          )}
          <div
            className={cn(
              'flex flex-col items-center bg-white px-4 py-6 mx-4 rounded-xl lg:mb-20 mt-0',
              !showRightSection ? 'lg:mt-0' : 'lg:mt-20',
              containerClassName,
            )}
          >
            {children}
          </div>
        </div>
      </div>
      {showRightSection && (
        <div className='lg:block hidden h-screen pl-1 pr-4 py-4 relative'>
          {rightSection ?? (
            <AuthPageRightSection isAgentContext={isAgentContext} />
          )}
        </div>
      )}
      {eventName && <AnalyticsEventOnLoad eventName={eventName} />}
    </div>
  );
};

export default AuthPageLayout;
